import Icon from '../components/Icon.vue'

Icon.register({"video":{"width":576,"height":512,"paths":[{"d":"M336.2 64H47.8C21.4 64 0 85.4 0 111.8V400.2C0 426.6 21.4 448 47.8 448H336.2C362.6 448 384 426.6 384 400.2V111.8C384 85.4 362.6 64 336.2 64zM525.6 101.7L416 177.3V334.7L525.6 410.2C546.8 424.8 576 409.9 576 384.4V127.5C576 102.1 546.9 87.1 525.6 101.7z"}]}})



// WEBPACK FOOTER //
// ./node_modules/vue-awesome/icons/video.js